import React, { useEffect, useState } from 'react'
import DocumentCraft from 'assets/images/document-craft.png';
import Common from '../login/common';
import Button from 'components/button';
import { uploadDocumentStatus } from 'constants/contants'
import RouteEnum from 'constants/routesEnum';
import { useSelector } from 'react-redux';
import { RootStateTypes } from 'ts/reducer';

function DocumentStatus(props) {
    const { type } = props.match.params;
    const { user } = useSelector((state: RootStateTypes) => state.auth)
    const [isValidStatus, setIsValidStatus] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // ✅ SIMPLIFIED: Since privateRoute already validated, just check locally
        if (!user?.UserID) {
            props.history.push(RouteEnum.Login);
            return;
        }

        // Validate status matches user's actual document status
        let isValid = false;

        if (type === uploadDocumentStatus.sent) {
            // Show 'sent' only if: uploaded AND verified is null (waiting for verification)
            isValid = (user.IsDocumentUploaded === true && user.IsVerified === null);
        }
        else if (type === uploadDocumentStatus.rejected) {
            // Show 'rejected' only if: verified is false (rejected by admin)
            isValid = (user.IsVerified === false);
        }
        else if (type === uploadDocumentStatus.approved) {
            // Show 'approved' if: verified is true (admin reviewed documents)
            // This can be IsApproved true OR false - just means documents are verified by admin
            isValid = (user.IsVerified === true);
        }

        if (!isValid) {
            console.warn(`Invalid status type or user status mismatch: ${type}`);
            console.warn(`Type: ${type}, IsVerified: ${user.IsVerified}, IsApproved: ${user.IsApproved}`);
            props.history.push(RouteEnum.Dashboard);
            return;
        }

        setIsValidStatus(true);
        setIsLoading(false);
    }, [type, user?.UserID, user?.IsVerified, user?.IsApproved])

    if (isLoading) {
        return (
            <div className="documents-upload__container documents-upload__container-status">
                <Common isHeader>
                    <div className="documents-upload documents-upload-status">
                        <div className="documents-upload__titles">
                            <div className="documents-upload__titled">Loading...</div>
                        </div>
                    </div>
                </Common>
            </div>
        );
    }

    if (!isValidStatus) {
        return null;
    }

    return (
        <div className="documents-upload__container documents-upload__container-status">
            <Common isHeader>
                <div className="documents-upload documents-upload-status">
                    <div className="documents-upload__titles">
                        <div className="documents-upload__titled">
                            {
                                uploadDocumentStatus.sent === type ? "Document Received!" :
                                    uploadDocumentStatus.rejected === type ? "Document Rejected" :
                                        uploadDocumentStatus.approved === type ? "Document Approved" : null
                            }
                        </div>
                        <div className="documents-upload__sub">
                            {
                                uploadDocumentStatus.sent === type ? "Document approval takes may upto 24 hours or two working days." :
                                    uploadDocumentStatus.rejected === type ? "Your document has been rejected. For more information check your email" :
                                        uploadDocumentStatus.approved === type ? "Your document has been approved. For more actions, visit Dashboard." : null
                            }
                        </div>
                    </div>
                    <div className="documents-upload__button login-btn-block">
                        {
                            uploadDocumentStatus.rejected === type ?
                                <Button
                                    onClick={() => props.history.push(RouteEnum.UploadDocuments)}
                                    title="Re-submit"
                                    size="large"
                                    bg="primary"
                                /> :
                                uploadDocumentStatus.approved === type ?
                                    <Button
                                        onClick={() => props.history.push(RouteEnum.Trekkers)}
                                        title="Go to Dashboard"
                                        size="large"
                                        bg="primary"
                                    /> : null
                        }
                    </div>
                </div>
            </Common>
        </div>
    )
}

export default DocumentStatus